// extracted by mini-css-extract-plugin
export default {"invalid_link":"InvalidLink_invalid_link__Z3qah"};